export default __webpack_public_path__ + "static/media/gallery-image-7.f9f08daf.jpg";